import { defineMessages } from 'react-intl';

export const scope = 'app.components.NoContent';

export default defineMessages({
  defaultText: {
    id: `${scope}.defaultText`,
    defaultMessage: 'No content yet',
  },
});
